const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { MomentOwned, acquiredType } from './MomentOwned';
import * as utils_time from './utils_time'
import * as utils_topshot from './utils_topshot'

export type sortOrderTypes = 'SoldPrice_DESC' | 'SoldPrice_ASC' | 'AcquiredPrice_DESC' | 'AcquiredPrice_ASC'  | 'AcquiredDate_DESC' | 'AcquiredDate_ASC' | 'SoldDate_DESC' | 'SoldDate_ASC' | 'Movement_DESC' | 'Movement_ASC' | 'Gain_ASC' | 'Gain_DESC'

export class MomentSold extends MomentOwned {
  public saleDate: Date = null
  public salePrice: number = null
  public buyerAddress: string = null
  public buyerUsername: string = null
  public buyerImageURL: string = null
  public thenFMV: number = null
  public wasAuction: boolean = null

  // just for processing, not for client
  private sale: any = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object) {
    super(po)
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    if (typeof this.saleDate === 'string') this.saleDate = new Date(this.saleDate)
  }

  public isSafe(): boolean {
    if (!super.isSafe()) return false
    if (this.sale) return false
    return true
  }

  public getNiceGainString(): string {
    const numericalGain: number = this.salePrice - this.buyPrice
    const nice: string = `${ numericalGain < 0 ? '-' : '+'}${utils_topshot.getNicePriceString(Math.abs(numericalGain))}`
    return nice
  }
  public getGainClass(): string {
    if (this.salePrice >= this.buyPrice) return 'positive'
    return 'negative'
  }
  public getNiceBuyerString(): string {
    return this.buyerUsername || this.buyerAddress
  }
  public getNiceHoldTimeString(): string {
    if (!this.saleDate || !this.acquiredDate) return ''
    const timeDiff: number = this.saleDate.getTime() - this.acquiredDate.getTime()
    return `Held for ${utils_time.shortTimeDiff(timeDiff)}`
  }
}

(async () => {
})();
